import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { useQuery, useMutation } from '@apollo/client';
import { GET_URLS_DATA } from '../../../GraphQL/ManageUrls/TRFX/Queries';
import { EDIT_URL_FROM_CONTEXT } from '../../../GraphQL/ManageUrls/TRFX/Mutations';

function EditUrlForm() {
  const errorHandler = (error) => {
    window.flash(error, 'error');
  };
  const navigate = useNavigate();
  const [newUrl, setNewUrl] = useState('');
  const [currentUrl, setCurrentUrl] = useState('');
  const [urlContextId, setUrlContextId] = useState('');
  const [urlDataSource, setUrlDataSource] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [runMutation] = useMutation(EDIT_URL_FROM_CONTEXT);

  useQuery(GET_URLS_DATA, {
    onCompleted: (data) => {
      if (data.contextGetAllUrls !== null) {
        setUrlDataSource(data.contextGetAllUrls);
      } else {
        errorHandler('No urls defined');
      }
    },
    onError: (error) => errorHandler(error.message),
  });

  const validateForm = () => {
    const errors = {};

    if (!urlContextId) {
      errors.url = '*Please select a URL';
    }

    if (!newUrl) {
      errors.newUrl = '*Please enter a new URL';
    } else if (
      !/^(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/[\w#!:.?+=&%!\-/])?$/.test(
        newUrl
      )
    ) {
      errors.newUrl = '*Please enter a valid URL';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    window.showMessage('Loading', 'loading');
    runMutation({
      variables: {
        contextId: urlContextId,
        toDeleteUrl: currentUrl,
        toUpdateUrl: newUrl,
      },
    })
      .then((r) => {
        const response = r.data.contextSaveEditedUrl;
        if (response === null) {
          window.hideMessage();
          window.flash('Context not found. Url cant be updated', 'error');
        } else {
          window.hideMessage();
          window.flash('Url successfully updated.', 'success');
          setNewUrl('');
          setCurrentUrl('');
          setUrlContextId('');
          navigate('/edit-url');
        }
      })
      .catch((error) => {
        window.hideMessage();
        window.flash('An error occurred. Url cant be updated', 'error');
      });
  };

  const urlsDropDownOnchange = (e) => {
    const selectedUrl = urlDataSource.find((url) => url.id === e.value);
    if (selectedUrl) {
      setCurrentUrl(selectedUrl.name);
      setUrlContextId(selectedUrl.id);
    }
  };

  return (
    <div className='d-flex justify-content-center'>
      <div className='e-card' style={{ width: '70%' }}>
        <div className='e-card-header mt-2' style={{ width: '100%' }}>
          <div className='e-card-header-caption' />
        </div>
        <form
          onSubmit={(event) => onSubmit(event)}
          className='mr-3 ml-3'
          id='editUrlForm'
        >
          <div className='form-group'>
            <Dropdown
              id='url-dropdown'
              value={urlContextId}
              options={urlDataSource}
              optionLabel='name'
              optionValue='id'
              placeholder='Select URL'
              className={formErrors.url ? 'p-invalid w-50' : 'w-50'}
              onChange={urlsDropDownOnchange}
              filter
              filterBy='name'
              virtualScrollerOptions={{ itemSize: 38 }}
            />
            {formErrors.url && (
              <small className='p-error'>{formErrors.url}</small>
            )}
          </div>
          <div className='mb-3 mt-3 form-group'>
            <InputText
              type='text'
              value={newUrl}
              onChange={(e) => setNewUrl(e.target.value)}
              placeholder='Set new URL'
              className={formErrors.newUrl ? 'p-invalid w-50' : 'w-50'}
            />
            {formErrors.newUrl && (
              <small className='p-error'>{formErrors.newUrl}</small>
            )}
          </div>
          <div className='d-flex justify-content-center mt-5 form-group'>
            <Button
              type='button'
              label='Cancel'
              icon='pi pi-times'
              className='p-button-outlined mr-2'
              onClick={() => navigate('/trfx-test-executions')}
            />
            <Button
              type='submit'
              label='Accept'
              icon='pi pi-check'
              className='p-button-primary'
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUrlForm;
